import { Component, Input, OnInit } from "@angular/core"
import { UserService } from "../../../services/user.service"
import { CardComponent } from "../card.component"

@Component({
    selector: "app-collection-search-card",
    templateUrl: "./collection-search-card.component.html",
    styleUrls: ["./collection-search-card.component.scss"],
})
export class CollectionSearchCardComponent extends CardComponent implements OnInit {
    @Input() public gtmDataCardNumber: number

    constructor(public userService: UserService) {
        super(userService)
    }

    public ngOnInit() {
        this.showAsCollection = true
    }
}
